import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SoporteService } from '../services/soporte.service';
import { MensajeSoporte } from '../entities/mensaje-soporte';
import { LoadingComponent } from 'app/common/loading/loading.component';
import { AlertDialogComponent } from 'app/common/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-soporte',
  templateUrl: './soporte.component.html',
  styleUrls: ['./soporte.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SoporteComponent {

  mensajeSoporte: MensajeSoporte;
  mensajeSoporteForm: FormGroup;
  esUnMensajeDeError: boolean = false;
  data : any;

  constructor(
    public matDialogRef: MatDialogRef<SoporteComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _formBuilder: FormBuilder,
    private _soporteService: SoporteService, 
    private _matDialog: MatDialog
  ) 
  { 
    this.data = _data;
    this.mensajeSoporte = new MensajeSoporte();
    this.mensajeSoporteForm = this.createMensajeSoporteForm();
  }

  marcarMensajeComoSugerencia(): void{
    this.esUnMensajeDeError = false;
  }

  marcarMensajeComoError(): void{
    this.esUnMensajeDeError = true;
  }

  createMensajeSoporteForm(): FormGroup {
    return this._formBuilder.group({
      asunto: [this.mensajeSoporte.asunto, Validators.required],
      mensaje: [this.mensajeSoporte.mensaje, Validators.required]
    });
  }

  enviarMensajeSoporte(){
    let loading = this._matDialog.open(LoadingComponent, { panelClass: 'loading'});
    
    this.mensajeSoporte = this.mensajeSoporteForm.value;
    this.mensajeSoporte.imagen = this.data.captura;
    this.mensajeSoporte.url = window.location.href;
    this.mensajeSoporte.esUnMensajeDeError = this.esUnMensajeDeError;

    this._soporteService.post(this.mensajeSoporte)
      .subscribe(result => {
        loading.close();

        if(!result.error){
          this._matDialog.open(AlertDialogComponent, {panelClass: 'alert', data: { titulo : 'Atención', mensaje: result.mensaje}});
          this.matDialogRef.close();
        }

      });
  }

}


